import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

interface ResendCountdownProps {
  onPress: () => void
  noReset?: boolean
  initialSeconds?: number
}

export const ResendCountdown: React.FC<ResendCountdownProps> = ({
  onPress,
  noReset = false,
  initialSeconds = 60,
}) => {
  const { t } = useTranslation()
  const [isOn, setIsOn] = useState(false)
  const [timeLeft, setTimeLeft] = useState(initialSeconds)

  useEffect(() => {
    if (!isOn) return

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          setIsOn(false)
          return initialSeconds
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [isOn, initialSeconds])

  const handlePress = useCallback(() => {
    if (isOn) return

    onPress()
    setIsOn(true)
    if (!noReset) {
      setTimeLeft(initialSeconds)
    }
  }, [isOn, onPress, noReset, initialSeconds])

  return (
    <button
      onClick={handlePress}
      disabled={isOn}
      className={`text-sm text-base font-medium ${
        isOn
          ? 'text-gray-500 cursor-not-allowed'
          : 'text-blue-400 hover:text-blue-300 cursor-pointer'
      }`}
    >
      {t('translation:signup.resend')} {isOn && `(${timeLeft}s)`}
    </button>
  )
}
